<script lang="ts">
/**
 * The "SDKs" sticker, artwork only.
 *
 * Extracted from `documentation/assets/remote/cdn-a0d352f9ce.svg` (the `SDKSticker` group, without
 * the peel wrapper and lighting filters) and optimised with `svgo --multipass -p 1` using
 * `preset-default` with `removeViewBox: false` and `cleanupIds: false`. The viewBox is cropped to
 * the artwork's bounding box. Re-export it the same way.
 */
export default {}
</script>

<template>
  <svg
    aria-hidden="true"
    class="explore-scalar-sticker block h-auto"
    data-sticker="sdks"
    fill="none"
    focusable="false"
    viewBox="0 0 144 143"
    xmlns="http://www.w3.org/2000/svg">
    <path
      class="explore-sticker-purple"
      d="M60 8.6a15.1 15.1 0 0 1 26.6.4l55.8 106.4a6 6 0 0 1-5.4 8.8l-22.3-.3-.6 11.9a7 7 0 0 1-7.2 6.8l-74-.8a7 7 0 0 1-7-7l-.5-12-19.1-.3a6 6 0 0 1-5.2-9z"
      fill="#5a00da" />
    <path
      d="m64.5 12.6-.2-.2zm17.4.2.3-.1zM136.1 116l.2-.2zM7.3 114.3l-.2-.1zM64.5 12.6l.3.1a9.6 9.6 0 0 1 16.9.3l.2-.2.3-.1c-3.8-7.2-14-7.3-18-.3zm17.4.2-.2.2 54.1 103 .3-.1.2-.2-54.1-103zM136.1 116l-.3.1a1 1 0 0 1-.8 1.3v.6a1.5 1.5 0 0 0 1.3-2.2zm-1 1.7v-.3L8.2 115.8v.6L135 118zM8.2 116v-.3a1 1 0 0 1-.7-1.3l-.3-.2-.2-.1a1.5 1.5 0 0 0 1.2 2.2zm-1-1.8.3.2L64.8 12.7l-.3-.1-.2-.2L7 114.2z"
      fill="#dcdcdc" />
    <path
      class="explore-sticker-purple"
      d="m87 18-5 2.4L97.5 48l5-3zm-54.2 96.8 75.3 1-.2 13.2-75.2-1z"
      fill="#5a00da" />
    <text
      fill="#bebebe"
      stroke="#bebebe"
      stroke-width=".1"
      style="font-size: 22.75px; font-weight: 700"
      transform="rotate(.726 -8815.25 3286.405)">
      <tspan
        x="0"
        y="22.3">
        SDKs
      </tspan>
    </text>
    <path
      d="m74.8 11.7.2.2v2.4l1.7-1.7h.3l1.3 1.3v.3L76.5 16H79a.2.2 0 0 1 .2.3V18a.2.2 0 0 1-.3.2h-2.4l1.7 1.7v.3L77 21.5h-.3L75 19.8v2.4l-.2.2h-1.9l-.2-.2v-2.5L71 21.4h-.3l-1.3-1.3v-.3l1.8-1.7h-2.5l-.2-.2V16a.2.2 0 0 1 .3-.2H71l-1.7-1.7v-.3l1.3-1.2h.3l1.7 1.7v-2.4a.2.2 0 0 1 .3-.3zm24.4 49q.3.5.3 1c.4 4.8-.4 10 0 14.8l13.2 7.8v16.6L98.6 109 85 101.7 72.8 109l-.7.2-13.4-7.5-13 7.5-.8-.2-13.5-8.1V84.1l13.1-7.5.2-15.4c.2-.6 1.9-1.5 2.5-1.8l10.7-6V38.1c.2-.5 3.1-2.1 3.8-2.5l10.6-6 13.9 8.2c.5.6 0 1.3 0 2V53zm-38-21.9 11 6.2L83 38.5l-10.6-6.3-11 6.1zm10 20.8V47.4l-.8-.8L60.2 41v12.6zM70 61.5l-11-6.2-11.3 6.6 11.2 6.6L69.6 62zm26.6 0L85 55.3l-10.6 6.3 10.9 6.7zM84.3 83V70.3l-11.2-6.6v12.9zm-26.6-.3V70.5L47 64v12.4l8.6 5.2c.3.2 2 1.3 2.2 1.1m-1 2.1L46 78.5l-11.6 6.3 11.3 6.8 11-6.2zm26.7 0-11.3-6.3-11 6.3-.2.4 11 6.2 11.3-6.1zm26.4.2-11.3-6.4L87.3 85l11.2 6.6zm-65.2 8.5-10.8-6.3-.4.2v12.1l11.2 6.6zM71 106.3V93.6q-5.5-3.5-11.2-6.5v12.4zm26.6 0V93.8l-11.2-6.5v12.5z"
      fill="#dcdcdc" />
    <text
      fill="#dcdcdc"
      style="font-size: 3.5px; font-weight: 800"
      transform="rotate(62.7 27.4 82.8)">
      <tspan
        x="0"
        y="3.5">
        SCALAR.COM
      </tspan>
    </text>
    <text
      fill="#fff"
      style="font-size: 4.083px; font-weight: 800"
      textLength="92"
      transform="rotate(.726 -9781.13 2693.84)">
      <tspan
        x=".1"
        y="3.7">
        SOFTWARE • DEVELOPMENT • KITS
      </tspan>
    </text>
  </svg>
</template>

<style scoped>
/* The printed colours, with the wider-gamut originals where the display can show them */
.explore-sticker-purple {
  fill: #5a00da;
}
@media (color-gamut: p3) {
  .explore-sticker-purple {
    fill: color(display-p3 0.321569 0.011765 0.819608);
  }
}
text {
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,
    Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}
</style>
